import { Grid } from '@chakra-ui/react';
import useNftCollectionActive from '@ui/hooks/useNftCollectionActive';
import type { NftCollection } from '@veno-app/sdk';
import React from 'react';

import StakeCruiserCard from '../GardenNftDrawersShared/StakeCruiserCard';
import type { CollectionNft, StakeableNft } from '../types';

type NftSelectionProps = {
  nfts: StakeableNft[];
  selectedTokens: CollectionNft[];
  onSelect: (tokenId: string, collection: NftCollection) => void;
  onDeselect: (tokenId: string, collection: NftCollection) => void;
  maxNForSelect?: number;
  collectionToCheckForActive?: NftCollection;
};

const NftSelection: React.FC<NftSelectionProps> = ({
  nfts,
  selectedTokens,
  maxNForSelect,
  onSelect,
  onDeselect,
  collectionToCheckForActive,
}) => {
  const collectionActive = useNftCollectionActive(collectionToCheckForActive);

  return (
    <Grid
      mx="auto"
      mt={4}
      mb={2}
      rowGap={4}
      columnGap={5}
      templateColumns="repeat(3, 1fr)"
    >
      {nfts?.map((nft) => {
        const active = !!selectedTokens.find(
          (st) => st.id === nft.id && st.collection === nft.collection,
        );
        const disabled = !active && selectedTokens.length === maxNForSelect;
        return (
          <StakeCruiserCard
            checkable={collectionActive}
            key={nft.id}
            onClick={(e) => {
              e.stopPropagation();
              if (disabled || !collectionActive) return;
              if (active) {
                onDeselect(nft.id, nft.collection);
              } else {
                onSelect(nft.id, nft.collection);
              }
            }}
            disabled={disabled}
            active={active}
            p="8px 8px 16px"
            {...nft}
          />
        );
      })}
    </Grid>
  );
};

export default NftSelection;
